module.exports = __webpack_public_path__ + "img/hight.564d1517.svg";